@if (initialized && promotions && promotions.length > 0) {

    @for (promotion of promotions; track promotion.id) {
      <div class="surface-card border-round shadow-2 p-6 flex justify-content-between mt-4 align-items-center" style="background: rgb(2,0,36);
background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,53,88,1) 75%);">
        <div class="flex flex-column justify-content-center align-items-center md:align-items-start">
          <div class="text-900 font-medium mb-2 text-2xl md:text-4xl text-white-alpha-90">{{ promotion.mainLabel}}</div>
          <p class="mt-0 mb-4 p-0 line-height-3 text-white-alpha-90">{{ promotion.text}}</p>
          <span class="flex flex-column md:flex-row align-items-center">
            <a [href]="promotion.url"  class="p-button text-white" target="_blank" rel="noopener noreferrer">{{promotion.urlText}}</a>
<!--            <p-button pRipple [text]="true" label="Nimm Kontakt auf"></p-button>-->
          </span>
        </div>
        <img [src]="promotion.imageUrl" class="border-circle max-h-10rem max-w-10rem w-4" style="height: fit-content" />
      </div>
    }
}
